import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { countries, continents } from "countries-list";
import { Link, useLocation } from "react-router-dom";
import { format } from "date-fns";
import { DateTime } from "luxon";
// material ui
import { makeStyles } from "@mui/styles";
import {
    Box,
    Grid,
    InputLabel,
    MenuItem,
    FormControl,
    FormHelperText,
    Select,
    IconButton,
    Autocomplete,
    TextField,
    Input,
    Stack,
   
} from "@mui/material";
// icons
import EmailIcon from "@mui/icons-material/Email";

// components
import Layout from "../../layout/Layout";
import { ASSESSMENT_BASE_URL } from "../../utils/config";
import {
    MuiDataGrid,
    MuiAutocomplete,
    geographyArr,
    GridCellExpand,
    ModalPopUp,
    FormSubmitButton,
    FormTextField as MyTextInput,
    Notifier,
    ErrorNotifier,
    ModalCloseBtn,
    ConfirmDialog,
    MuiTooltip,
    CommonCurdPopUp
} from "../../components";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";

import { isCheckingAssessmentType } from "../../components/common/IsCheckingAssessmentType";
import BatchTableData from "./BatchTableData"
// redux
import { createBatchPublishAssessment, getBatchNonPublishAssessment, updateBatchPublishAssessment, getBatchPublishAssessment, deleteBatchAssessment, getBatchPublishAssessmentById, getPublishAssessmentById, resetErrMessage, resetMessage } from "../../features/config_and_publish/publishAssessmentSlice";
import { getAccount, getAccountById } from "../../features/customer/accountSlice";
import { getCustomer } from "../../features/customer/customerSlice";
import { getPlatformStatus } from "../../features/config/platformStatusSlice";

import CommonCrudPopup from "../../components/form_components/CommonCrudPopup";
import { getassessmentType, setAssessmentType } from "../../features/config/assessmentTypeSlice";
// ------------------------------------------------------------------------------

const validationSchema = Yup.object({
    // assessment: Yup.array().nullable().required("Assessment Template Name is required"),
    // assessmentType: Yup.object().nullable().required("Assessment Type is required"),
    account: Yup.object().nullable().required("Account Name is required"),
    custName: Yup.object().nullable().required("Customer is required"),
    batchName: Yup.string().required("Batch Name is required")
});

const editValidationSchema = Yup.object({

    batchName: Yup.string().required("Batch Name is required"),
    status: Yup.string().required("Status is required"),

});


// -------------------------------------------------------------------------

const style = {
    position: "absolute",
    top: "50%",
    left: "60%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
};

// ------------------------------------------------------------------------


const ConfigAndPublish = (props) => {
    const [showAdd, setShowAdd] = useState(false);
    const [open,setOpen] = useState(false)
    const [batchName,setBatchName] = useState(null)
    // const [assessmentType, setAssessmentType] = useState(null)
    const [showEdit, setShowEdit] = useState(false);
    const [viewArchived, setViewArchived] = useState(false)
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });
    const [showCutoffDate, setShowCutoffDate] = useState(false);
    const [cutoffDateSelectedData, setCutoffDateSelectedData] = useState({});
    const [showReminderFreq, setShowReminderFreq] = useState(false);
    const [reminderFreqSelectedData, setReminderFreqSelectedData] = useState({});
    const [selectedCustValue, setSelectedCustValue] = useState(null)
    const [selectedAccountValue, setSelectedAccountValue] = useState(null)
    const [dateErr, setDateErr] = useState("");

    const dispatch = useDispatch();
    const location = useLocation();
    const { message, errMessage, publishAssessmentData, batchAssessmentData, nonPublishAssessmentData, selectedData, loading } =
        useSelector((state) => ({ ...state.publishAssessment }));
    const { assessmentTemplateData } = useSelector((state) => ({
        ...state.prepareAssessment,
    }));
    const { assessmentTypeData, assessmentType } = useSelector((state) => ({
        ...state.assessmentTypeConfig,
    }));
    const { assessmentTemplateStatusData } = useSelector((state) => ({
        ...state.assessmentTemplateStatus,
    }));
    const { accountData, accountIdData } = useSelector((state) => ({ ...state?.account }));
    const { customersData } =
        useSelector((state) => ({ ...state.customer }));
    const { custUserData } = useSelector((state) => ({ ...state?.custUser }));

    const { assessmentStatusData } = useSelector((state) => ({
        ...state?.assessmentStatus,
    }));
    const showAddModel = () => {
        setShowAdd(!showAdd);

    };

    const closeModel = () => {
        setShowAdd(false);
        const { account, custName } = formik?.values
        // formik.resetForm({
        //     values: {
        //         account,
        //         custName,
        //         assessmentType: assessmentType,
        //         assessment: "",
        //         client: "",
        //         status: "",
        //         comments: "",
        //     },
        // });
        // dispatch(getAccount())
    };

    const showEditModal = () => {
        setShowEdit(true);
    };
    const closeEditModal = () => {
        setShowEdit(false);


    };

    const showCutoffDateModal = (data) => {
        setShowCutoffDate(true);
        setCutoffDateSelectedData(Object.keys(data)?.length > 0 ? data : {});
    };

    const closeCutoffDateModal = () => {
        setShowCutoffDate(false);
    };

    const showReminderFreqModal = (data) => {
        setShowReminderFreq(true);
        setReminderFreqSelectedData(data);
    };

    const closeReminderFreqModal = () => {
        setShowReminderFreq(false);
    };

    const showDelete = () =>
        setConfirmDialog({
            isOpen: true,
            title: "Are you sure to delete this record?",
            subTitle: "You can't undo this operation",
            //   onConfirm: () => handleDeleteCustomer(),
        });

    const handleSetConfirmDialog = (obj) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: obj.isOpen,
        });
    };

    function getAssessment(value,  params) {
        return params?.assessmentTemplate?.assessmentTemplateDisplayName;
    }

    function getAssessmentTemplateMui(value,  params) {
        return params?.assessmentTemplate?.assessmentTemplateName;
    }

    function getClient(value,  params) {
        return `${params.assessmentCustomerUser?.assessmentCustomerUserDetail
            ?.firstName || ""
            } ${params.assessmentCustomerUser?.assessmentCustomerUserDetail
                ?.lastName || ""
            }`;
    }

    function getClientEmail(params) {
        return (
            <GridCellExpand
                value={params?.row?.assessmentCustomerUser?.email}
                width={params?.colDef?.computedWidth}
            />
        );
    }

    function getAccountName(params) {
        return (
            <GridCellExpand
                value={`${params?.row?.assessmentCustomerUser?.assessmentCustomer?.customerName}-${params?.row?.assessmentCustomerUser?.assessmentCustomer?.accountName}`}
                width={params?.colDef?.computedWidth}
            />
        );
    }

    function renderCellExpand(params) {
        return (
            <GridCellExpand
                value={params.value || ""}
                width={params.colDef.computedWidth}
            />
        );
    }

    const formik = useFormik({
        reset: true,
        initialValues: {

            assessment: [],
            assessmentType: null,
            account: "",
            custName: "",
            batchName: ""
        },

        validationSchema: validationSchema,
        onSubmit: async (values, onSubmitProps) => {
            const res = await dispatch(
                createBatchPublishAssessment({
                    batchName: values?.batchName,
                    assessmentTrackingIds: values?.assessment?.map((data) => data?.id),
                    // assessmentTypeId: values?.assessmentType?.id,
                    assessmentCustomerAccountId: values?.account?.id,


                })
            ).then((res) => {
                if (res?.payload?.data?.ok) {
                    setTimeout(() => {
                        dispatch(resetMessage());
                        closeModel();
                        dispatch(getBatchPublishAssessmentById())
                        onSubmitProps.resetForm();
                    }, 2000);
                    return true;
                }
                if (res?.payload?.error) {
                    setTimeout(() => {
                        dispatch(resetErrMessage());
                    }, 3000);
                }
                return false;
            });
            return res;
        },
    });

  

    const formikEdit = useFormik({
        enableReinitialize: true,
        initialValues: {
            batchName: selectedData?.name,
            status: selectedData?.status,
        },
        validationSchema: showEdit && editValidationSchema,
        onSubmit: async (values, onSubmitProps) => {
            const res = await dispatch(
                updateBatchPublishAssessment({
                    id: selectedData?.id,
                    batchName: values?.batchName,
                    status: values.status
                })
            ).then((res) => {
                if (res?.payload?.data?.ok) {
                     closeEditModal();
                    setTimeout(() => {
                          
                        dispatch(resetMessage());
                        
                        Array.isArray(batchAssessmentData?.data) 
                        ? dispatch(getBatchPublishAssessmentById()) : 
                        dispatch(getBatchPublishAssessment({ id: batchAssessmentData?.data?.id }))
                        onSubmitProps.resetForm();
                    }, 2000);
                    return true;
                }
                if (res?.payload?.error) {
                    setTimeout(() => {
                        dispatch(resetErrMessage());
                    }, 3000);
                }
                return false;
            });
            return res;
        },
    });

   

    const handleUpdateIsCompletedCustomer = () => {
        const dateResult = DateTime.fromISO(formikEdit?.values?.cutoffDate).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        let localIsoString = dateResult.toISO();

        let data = {
            id: selectedData?.id,
            assessmentTemplateId: formikEdit?.values.assessment?.id,
            assessmentCustomerUserId: formikEdit?.values.client?.id,

            assessmentStatus: formikEdit?.values?.status,
            cutOffDate: localIsoString,
            reminderFrequency: formikEdit?.values?.reminderFreq,
            comments: formikEdit?.values?.comments,
        };
        // dispatch(updatePublishAssessment(data)).then((res) => {
        //   if (res?.payload?.data?.ok) {
        //     setTimeout(() => {
        //       dispatch(resetMessage());
        //       closeEditModal();
        //       closeCutoffDateModal();
        //       closeReminderFreqModal();
        //       setConfirmDialog({
        //         ...confirmDialog,
        //         isOpen: false,
        //       });
        //       selectedCustValue && !selectedAccountValue ?
        //         dispatch(getPublishAssessmentByCustomerId({ assessmentCustomerId: selectedCustValue?.id }))
        //         : selectedAccountValue
        //           ? dispatch(getPublishAssessmentById({ assessmentCustomerAccountId: selectedAccountValue?.id }))
        //           : dispatch(getPublishAssessment());
        //     }, 2000);
        //   }
        //   if (res?.payload?.error) {
        //     setTimeout(() => {
        //       setConfirmDialog({
        //         ...confirmDialog,
        //         isOpen: false,
        //       });
        //       dispatch(resetErrMessage());
        //     }, 3000);
        //   }
        // });
    };

    let options = Object.values(countries);

    useEffect(() => {
        // dispatch(getPublishAssessment());
        // dispatch(getAssessmentTemplate());
        // dispatch(getCustUser());
        dispatch(getAccount())
        dispatch(getCustomer())
        dispatch(getBatchPublishAssessmentById())
        dispatch(getBatchNonPublishAssessment())
        dispatch(getPlatformStatus())
        // dispatch(getAssessmentStatus());
        dispatch(getassessmentType())
    }, []);

    console.log(nonPublishAssessmentData)

    useEffect(() => {

        if (!Boolean(location?.state?.assessmentType) && assessmentTypeData?.length > 0) {
            const defaultType = assessmentTypeData.find(
                (data) => data.code === "ELI"
            );

            if (defaultType) {
                dispatch(setAssessmentType(defaultType));
                formik.setFieldValue("assessmentType", defaultType);
            }
        }
    }, [assessmentTypeData]);

    useEffect(() => {
        if (!formik?.values?.account) {
            formik.setFieldValue("client", "");
        }
    }, [formik?.values?.account]);

    useEffect(() => {
        if (formik.values?.custName?.id) {
            dispatch(getAccountById({ assessmentCustomerId: formik.values?.custName?.id }))
        }

    }, [formik.values?.custName])

    useEffect(() => {

        dispatch(getPublishAssessmentById({ assessmentCustomerAccountId: formik?.values?.account?.id }))

    }, [formik?.values?.account])

    const getCustomerSelectedValue = (data) => {
        formik.setFieldValue("custName", data)
        setSelectedCustValue(data)
    }

    const getAccountSelectedValue = (data) => {
        formik.setFieldValue("account", data)
        setSelectedAccountValue(data)
    }

    // for this function changed the formik values to this component state variables
    const handleSubmit = async () => {
        if (showAdd) {
            const result = await formik.submitForm();
            return result;
        } else if (showEdit) {
            const result = await formikEdit.submitForm();
            return result;
        }

    };



    return (

        <>
            <>
                <BatchTableData showModal={showAddModel} showEditModal={() => setShowEdit(true)} />
            </>

            {showAdd && <CommonCurdPopUp
                heading={`Create Batch`}
                mediumScreen={true}
                close={
                    closeModel
                }
                handleSubmit={handleSubmit}
                loading={loading}
            >
                <Grid container >
                    <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
                    <Grid item xs={12} sm={12} md={11} >

                        {/* {


                            <MuiAutocomplete
                                name="assessmentType"
                                options={assessmentTypeData}
                                setValue={(name, newValue) => {

                                    formik.setFieldValue(name, newValue)
                                    // formik.setFieldValue("account", "")
                                    formik.setFieldValue("assessment", [])
                                    // formik.setFieldValue("templateDisplayName", "")
                                    // formik.setFieldValue("client", "");

                                }
                                }

                                value={formik.values.assessmentType}
                                optionValue="assessmentType"
                                label="Assessment Type"
                                required={true}
                                error={formik.touched.assessmentType && Boolean(formik.errors.assessmentType)}
                                helperText={formik.touched.assessmentType && formik.errors.assessmentType}
                            />} */}


                        <MuiAutocomplete
                            name="custName"
                            options={customersData}
                            setValue={(name, newValue) => {

                                formik.setFieldValue(name, newValue)
                                formik.setFieldValue("account", "")
                                // formik.setFieldValue("assessment", "")
                                // formik.setFieldValue("templateDisplayName", "")
                                // formik.setFieldValue("client", "");
                            }
                            }

                            value={formik.values.custName}
                            optionValue="customerName"
                            label="Customer"
                            required={true}
                            error={formik.touched.custName && Boolean(formik.errors.custName)}
                            helperText={formik.touched.custName && formik.errors.custName}
                        />

                        <MuiAutocomplete
                            name="account"
                            options={formik.values.custName && accountIdData ? accountIdData : []}
                            setValue={(name, newValue) => {
                                formik.setFieldValue(name, newValue)
                                dispatch(getBatchNonPublishAssessment(newValue?.id))
                                // formik.setFieldValue("assessment", "");
                                // formik.setFieldValue("templateDisplayName", "");
                                // formik.setFieldValue("client", "");
                            }

                            }

                            value={formik.values.account}
                            optionValue="accountName"
                            // optionSecValue="accountName"
                            label="Account Name"
                            required={true}
                            error={
                                formik.touched.account && Boolean(formik.errors.account)
                            }
                            helperText={formik.touched.account && formik.errors.account}
                        />








                        <MyTextInput
                            // InputLabelProps={{ shrink: true }}
                            label="Batch Name"
                            required={true}
                            type="text"
                            name="batchName"
                            fullWidth={true}
                            margin="normal"
                            id="batchName"
                            value={formik.values.batchName}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.batchName &&
                                Boolean(formik.errors.batchName)
                            }
                            helperText={
                                formik.touched.batchName &&
                                formik.errors.batchName
                            }

                        />
                        <MuiAutocomplete
                            multiple
                            name="assessment"
                            options={
                                nonPublishAssessmentData?.length > 0 ? nonPublishAssessmentData : []
                            }
                            setValue={(name, newValue) => {
                                formik.setFieldValue(name, newValue);

                            }}
                            disabled={!formik.values.account || nonPublishAssessmentData?.length === 0}
                            value={formik.values.assessment}
                            optionValue="assessmentTemplate"
                            optionSecValue="assessmentTemplateName"
                            optionFourthValue={true}

                            // innerValue={true}
                            label="Assessment Name"
                            // required={true}
                            error={
                                formik.touched.assessment &&
                                Boolean(formik.errors.assessment)
                            }
                            helperText={
                                formik.touched.assessment && formik.errors.assessment
                            }

                        />


                    
                    </Grid>
                </Grid>

            </CommonCurdPopUp>
            }


            {showEdit && <CommonCurdPopUp
                heading={`Update Batch`}
                mediumScreen={true}
                close={
                    () => setShowEdit(false)
                }
                handleSubmit={handleSubmit}
                loading={loading}
            >
                <Grid container >
                    <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
                    <Grid item xs={12} sm={12} md={11} >


                        {/* <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Assessment Type
                            </InputLabel>
                            <Select
                                disabled
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="assessmentType"
                                defaultValue={formikEdit?.values?.assessmentType}
                                value={formikEdit?.values?.assessmentType}
                                label="Assessment Type"
                                onChange={formikEdit.handleChange}
                                error={
                                    formikEdit.touched.assessmentType &&
                                    Boolean(formikEdit.errors.assessmentType)
                                }
                            >
                                {assessmentTypeData?.map((option) => {
                                    return (
                                        <MenuItem
                                            key={option.id}
                                            value={option.id}
                                        >
                                            {option.assessmentType}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                            <FormHelperText error={true} sx={{ color: "red" }}>
                                {formikEdit.touched.accountName && formikEdit.errors.accountName}
                            </FormHelperText>
                        </FormControl> */}


                        {/* <MuiAutocomplete
                            name="custName"
                            options={customersData}
                            setValue={(name, newValue) => {

                                formikEdit.setFieldValue(name, newValue)
                                formikEdit.setFieldValue("account", "")
                                formikEdit.setFieldValue("assessment", "")
                                formikEdit.setFieldValue("templateDisplayName", "")

                            }
                            }
                            disabled
                            value={formikEdit.values.custName}
                            optionValue="customerName"
                            label="Customer"
                            required={true}
                            error={formikEdit.touched.custName && Boolean(formikEdit.errors.custName)}
                            helperText={formikEdit.touched.custName && formikEdit.errors.custName}
                        /> */}

                        {/* <MuiAutocomplete
                            name="account"
                            options={formik?.values?.custName ? accountData.length > 0 ? accountData : accountIdData : []}
                            setValue={(name, newValue) => {
                                formikEdit.setFieldValue(name, newValue)
                                formikEdit.setFieldValue("assessment", "");
                                formikEdit.setFieldValue("templateDisplayName", "");
                                formikEdit.setFieldValue("client", "");
                            }

                            }
                            disabled
                            value={formikEdit.values.account}
                            optionValue="accountName"
                            // optionSecValue="accountName"
                            label="Account Name"
                            required={true}
                            error={
                                formikEdit.touched.account && Boolean(formikEdit.errors.account)
                            }
                            helperText={formikEdit.touched.account && formikEdit.errors.account}
                        /> */}



                        {/* <MuiAutocomplete
                            name="assessment"
                            options={
                                assessmentTemplateData?.length > 0 && formikEdit?.values?.account?.id ?
                                    assessmentTemplateData?.filter((data) => data?.
                                        assessmentCustomerAccount?.id === formikEdit?.values?.account?.id
                                    ) : []}
                            setValue={(name, newValue) =>
                                formikEdit.setFieldValue(name, newValue)
                            }
                            value={formikEdit.values.assessment}
                            // defaultValue={formikEdit?.values?.assessment}
                            optionValue="assessmentTemplateName"
                            label="Assessment Template Name"
                            required={true}
                            error={
                                formikEdit.touched.assessment &&
                                Boolean(formikEdit.errors.assessment)
                            }
                            helperText={
                                formikEdit.touched.assessment &&
                                formikEdit.errors.assessment
                            }
                            disabled={
                                formikEdit.values.status === "Published" ||
                                    formikEdit.values.status === "Completed"
                                    ? "disabled"
                                    : ""
                            }
                        /> */}

                        <MyTextInput
                            // InputLabelProps={{ shrink: true }}
                            label="Batch Name"
                            type="text"
                            name="batchName"
                            fullWidth={true}
                            margin="normal"
                            id="batchName"
                            value={formikEdit.values.batchName}
                             onBlur={formikEdit.handleBlur}
                            required={true}
                            onChange={formikEdit.handleChange}
                            error={
                                formikEdit.touched.batchName &&
                                Boolean(formikEdit.errors.batchName)
                            }
                            helperText={
                                formikEdit.touched.batchName &&
                                formikEdit.errors.batchName
                            }

                        />



                        <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Batch Status *
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="status"
                                value={formikEdit.values.status ? formikEdit.values.status : ""}
                                 onBlur={formikEdit.handleBlur}
                                // disabled={selectedData?.assessmentStatus === "Completed"}
                                error={
                                    formikEdit.touched.status &&
                                    Boolean(formikEdit.errors.status)
                                }
                                label="Assessment Status"
                                onChange={formikEdit.handleChange}
                            >
                                {assessmentStatusData.length > 0 &&

                                    assessmentStatusData.filter((data) => data?.assessmentStatus !== "Published")
                                        .map((item) => {
                                            return (
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.assessmentStatus}
                                                >
                                                    {item.assessmentStatus}
                                                </MenuItem>
                                            );
                                        })

                                }
                            </Select>
                            {formikEdit?.errors?.status && (
                                <FormHelperText error={true} sx={{ color: "red" }}>
                                    {formikEdit.touched.status && formikEdit.errors.status}
                                </FormHelperText>
                            )}
                        </FormControl>

                        {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formikEdit?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
                    </Grid>
                </Grid>


            </CommonCurdPopUp>}

           


        <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
            />

            {errMessage && <ErrorNotifier message={errMessage} />}
            {message && <Notifier message={message} />}
        </>

    );
};

export default ConfigAndPublish
